import React, { useRef, useState, useEffect } from "react";

const skills = [
  "JavaScript",
  "TypeScript",
  "React",
  "Node.js",
  "Tailwind CSS",
  "Firebase",
  "Responsive Design",
  "Git & GitHub",
  "AI Integration",
  "Python",
  "Automation",
  "Figma",
  "Framer",
  "Next.js",
  "Mern stack",
  "React Native",
  "aws",
  "dedvops",
  "Maschine Learning"
];

export default function Skills(props) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // optional: stop observing after animation
        }
      },
      {
        threshold: 0.3, // trigger when 30% of section is visible
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id={props.id}
      className={`max-w-4xl mx-auto px-4 transition-opacity duration-1000 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <h2 className="text-3xl font-semibold mb-8 text-center">Skills</h2>
      <div className="flex flex-wrap justify-center gap-5">
        {skills.map((skill, index) => (
          <span
            key={skill}
            className={`bg-blue-100 text-blue-700 px-5 py-3 rounded-full font-semibold shadow-sm hover:bg-blue-200 transition 
              ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"} 
              transition-all duration-700 delay-${index * 75}`}
          >
            {skill}
          </span>
        ))}
      </div>
    </section>
  );
}
